/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./model-color-picker.vue?vue&type=template&id=4f057031&"
import script from "./model-color-picker.vue?vue&type=script&lang=ts&"
export * from "./model-color-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports